import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "9b55c80b-c9d4-42e9-91a3-9660b325630b",
  publicId: "5",
  name: "Hearing Threshold (How its measured / age related changes)",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
